module.exports = __webpack_public_path__ + "static/media/facebook.26ab22c5.svg";